import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import PageHeader from '../../components/layout/PageHeader';
import Table from '../../components/ui/Table';
import Spinner from '../../components/ui/Spinner';
import EmptyState from '../../components/ui/EmptyState';
import Badge from '../../components/ui/Badge';
import { CandidateCell } from '../../components/requests/RequestActions';
import { fmtDateTime } from '../../components/requests/AssignDeadlineFields';
import CandidateFilterBar, { useCandidateFilters } from '../../components/filters/CandidateFilterBar';
import { listMyAssignedJobs } from '../../api/assignments';
import { ASSIGNED_JOBS_QUERY_KEY } from '../../hooks/useAssignedJobsCount';

const columns = [
  { key: 'candidate', label: 'Candidate', render: (row) => <CandidateCell candidate={row.candidate} /> },
  { key: 'category', label: 'Category', render: (row) => row.candidate.category || '—' },
  { key: 'step', label: 'Step', render: (row) => row.step.title },
  {
    key: 'assigned',
    label: 'Assigned',
    render: (row) => (
      <div>
        {row.assigned_by}
        <div className="text-xs text-gray-400">{fmtDateTime(row.assigned_at)}</div>
      </div>
    ),
  },
  {
    key: 'deadline',
    label: 'Deadline',
    render: (row) => (
      <div>
        {fmtDateTime(row.deadline)}
        {row.is_overdue && <Badge tone="red" className="ml-2">Overdue</Badge>}
        {row.waiting_approval && <Badge tone="amber" className="ml-2">Waiting for approval</Badge>}
      </div>
    ),
  },
  {
    key: 'actions',
    label: '',
    render: (row) => (
      <div className="flex justify-end">
        <Link
          to={`/candidates/${row.candidate.id}?step=${row.step.candidate_step_id}`}
          className="inline-flex items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-white hover:bg-primary-dark"
        >
          Complete
        </Link>
      </div>
    ),
  },
];

export default function AssignedSteps() {
  const filters = useCandidateFilters();
  const query = useQuery({
    queryKey: [...ASSIGNED_JOBS_QUERY_KEY, 'mine', filters.params],
    queryFn: () => listMyAssignedJobs(filters.params),
  });
  const rows = query.data || [];

  return (
    <div>
      <PageHeader title="Assigned Steps" description="Workflow steps assigned to you. Completing the step in the candidate workflow closes the job." />
      <CandidateFilterBar {...filters.barProps} />
      {query.isLoading ? (
        <div className="flex justify-center py-16">
          <Spinner />
        </div>
      ) : rows.length === 0 ? (
        <EmptyState title="No assigned jobs" message="Nothing is currently assigned to you." />
      ) : (
        <Table columns={columns} data={rows} />
      )}
    </div>
  );
}
